import { render, staticRenderFns } from "./LabelModulePreview.vue?vue&type=template&id=4bdf23bc&scoped=true&"
import script from "./LabelModulePreview.vue?vue&type=script&lang=js&"
export * from "./LabelModulePreview.vue?vue&type=script&lang=js&"
import style0 from "./LabelModulePreview.vue?vue&type=style&index=0&id=4bdf23bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf23bc",
  null
  
)

export default component.exports